import React from "react";
import Banner from "./Banner";
import { useParams } from "react-router-dom";
import { Helmet } from "react-helmet";
import {useBannerdata,useCatmetaTags} from "../FetchAPI";
import LangbyBlog from "./LangbyBlog";


export default function Blog() {
  let { language } = useParams();

    const [bannerdata] = useBannerdata();
    const [catmetaTags] = useCatmetaTags(language);



  return (
    <>
      <Helmet>
        <title>{catmetaTags.metatitle}</title>
        <meta name="keywords" content={catmetaTags.metakeyword} />
        <meta name="description" content={catmetaTags.metadescription} />
        <link rel="canonical" href={window.location.href} />
      </Helmet>



      <Banner
        Bnanerimage={bannerdata.blog_banner}
        image_title={bannerdata.blog_banner_title}
        image_alt={bannerdata.blog_banner_alt}
      />




      {/* Blog section Start */}

        <LangbyBlog
          language={language}
        />



      {/* Blog section End */}
    </>
  );
}
